import { render, staticRenderFns } from "./LastStep.vue?vue&type=template&id=c1bba648&scoped=true&"
import script from "./LastStep.vue?vue&type=script&lang=ts&"
export * from "./LastStep.vue?vue&type=script&lang=ts&"
import style0 from "./LastStep.vue?vue&type=style&index=0&id=c1bba648&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1bba648",
  null
  
)

export default component.exports